import { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isEmpty } from '@app/utils';
import BucketSearchInput from './BucketSearchInput/BucketSearchInput';
import BucketCheckbox from './BucketCheckbox/BucketCheckbox';

const BucketModelNumber = ({ isModal }) => {
  const [search, setSearch] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [showInput, setShowInput] = useState(true);
  const [inputError, setInputError] = useState(null);

  const bucketModelActiveFacet = useSelector(
    s => s.plpUI.bucketModelActiveFacet
  );
  const currentCategory = useSelector(s => s.plpUI.current);
  const bucketModelNumberResults = useSelector(
    s => s.categories.byId[currentCategory]?.bucketModelNumber
  );

  const searchInputRef = useRef(null);

  useEffect(() => {
    if (!isEmpty(bucketModelActiveFacet)) {
      setSubmitted(true);
      setShowInput(false);
    }
  }, [bucketModelActiveFacet]);

  const showSuggestions =
    search?.length > 1 && !isEmpty(bucketModelNumberResults) && !inputError;

  const handleSearchInputBlur = () => {
    requestAnimationFrame(() => {
      if (!searchInputRef.current.contains(document.activeElement)) {
        setInputError(null);
        setSearch('');
      }
    });
  };

  return (
    <div className="my-4">
      {showInput && (
        <div
          className="mb-2"
          ref={searchInputRef}
          onBlur={handleSearchInputBlur}
        >
          <BucketSearchInput
            inputError={inputError}
            search={search}
            setInputError={setInputError}
            setIsEditing={setIsEditing}
            setSearch={setSearch}
            setShowInput={setShowInput}
            setSubmitted={setSubmitted}
            showSuggestions={showSuggestions}
          />
        </div>
      )}
      {submitted && (
        <BucketCheckbox
          isEditing={isEditing}
          isModal={isModal}
          setIsEditing={setIsEditing}
          setSearch={setSearch}
          setShowInput={setShowInput}
          showInput={showInput}
        />
      )}
    </div>
  );
};

BucketModelNumber.propTypes = {
  isModal: PropTypes.bool
};

export default BucketModelNumber;
